import React from "react";

import { BeMappedNode, SplitNodeV2 } from "src/constants/NodeDataTypes";
import { getNodeTitleFromSelectedNode } from "src/nodeEditor/SidePaneHeader";
import { useGraphStore } from "src/store/StoreProvider";

export type SplitNodeDeletionModalContentProps = {
  splitNode: SplitNodeV2;
};

export const renderBranchNodes = (branchNodes: BeMappedNode[]) =>
  branchNodes.map((node: BeMappedNode) => {
    const nodeTitle = getNodeTitleFromSelectedNode(node);
    return (
      <div key={node.id} className="font-inter-normal-12px text-gray-500">
        • {node.data?.label}
        {nodeTitle && nodeTitle !== "" && ` (${nodeTitle})`}
      </div>
    );
  });

export const splitNodeDeletionDescription = (
  <div className="font-inter-normal-12px text-gray-500">
    Are you sure you want to delete this Node? This action cannot be undone. The
    following Nodes will also be deleted:
  </div>
);

export const renderBranches = (branchesToDelete: BeMappedNode[][]) => (
  <>
    {branchesToDelete.map((branchNodes: BeMappedNode[]) => (
      <div key={branchNodes[0].id} className="my-2">
        <span className="font-inter-medium-12px text-gray-800">
          {branchNodes[0].data.label}
        </span>
        <>{renderBranchNodes(branchNodes.slice(1))}</>
      </div>
    ))}
  </>
);

export const SplitNodeDeletionModalContent: React.FC<
  SplitNodeDeletionModalContentProps
> = ({ splitNode }) => {
  const { getBranchesAndNodes } = useGraphStore();

  return (
    <div className="decideScrollbar max-h-52 overflow-y-auto">
      {renderBranches(getBranchesAndNodes(splitNode, true))}
    </div>
  );
};
